import { router } from "expo-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "react-native";
import Animated, { FadeInRight } from "react-native-reanimated";

import ContactImage from "@/assets/contact.svg";
import LockImage from "@/assets/lock.svg";
import SearchImage from "@/assets/search.svg";
import Button from "@/components/button/Button";

interface Props {
  status: string;
}

export default function Status(props: Props) {
  const { t } = useTranslation();
  const checkTitle = (status: string) => {
    switch (status) {
      case "PENDING":
        return t("home/web3/index:status.pending");
      case "CREATED":
        return t("home/web3/index:status.created");
      case "REJECTED":
        return t("home/web3/index:status.rejected");
    }
  };
  const checkImage = (status: string) => {
    switch (status) {
      case "PENDING":
        return <LockImage className="w-64 h-56" />;
      case "CREATED":
        return <SearchImage className="w-64 h-56" />;
      case "REJECTED":
        return <ContactImage className="w-64 h-56" />;
    }
  };
  return (
    <Animated.View
      entering={FadeInRight}
      className="absolute z-50 h-full w-full items-center justify-center bg-white1 gap-6"
    >
      <Text className="text-2xl text-center font-light">
        {checkTitle(props.status)}
      </Text>
      {checkImage(props.status)}
      {props.status === "PENDING" && (
        <Button
          label={t("common:button.gotouserpanel")}
          onClick={() => {
            router.push("/home/userpanel");
          }}
        />
      )}
    </Animated.View>
  );
}
